<template>
  <a-layout :class="['a-board', over && 'is--over']">
    <canvas id="board" />
  </a-layout>
</template>

<script setup>
import {ref, watch} from 'vue'
import {useTranslation} from 'i18next-vue'
import {useMessageStore} from '@/stores/messagesStore'

const props = defineProps({
  over: {
    type: Boolean,
    default: false,
  },
  delayed: {
    type: Boolean,
    default: false,
  },
})

const {t} = useTranslation()
const message = useMessageStore()
const delayPromiseResolve = ref(null)
watch(props.delayed, delayed => {
  if (delayed) {
    message.addMessage({
      text: t('meeting.board.delayed'),
      timeout: -1,
      promise: new Promise(resolve => (delayPromiseResolve.value = resolve)),
    })
  } else if (delayPromiseResolve.value) {
    delayPromiseResolve.value()
    delayPromiseResolve.value = null
  }
})
</script>

<style lang="scss">
.a-board {
  z-index: $zindex-default;
  &.is--over {
    z-index: ($zindex-video + 1);
  }
  &:not(.is--over) {
    background-color: $black;
  }
}
</style>
